class Coordinate {
    constructor(x, y) {
        this.x = x !== null && x !== void 0 ? x : 0;
        this.y = y !== null && y !== void 0 ? y : 0;
    }
    toString() {
        return this.x + " " + this.y;
    }
    equals(other) {
        return this.x === other.x && this.y === other.y;
    }
    translate(dx, dy) {
        return new Coordinate(this.x + dx, this.y + dy);
    }
    rotate(deg) {
        let theta = -deg * Math.PI / 180;
        let cos = Math.cos(theta);
        let sin = Math.sin(theta);
        return new Coordinate(this.x * cos - this.y * sin, this.x * sin + this.y * cos);
    }
    add(other) {
        return new Coordinate(this.x + other.x, this.y + other.y);
    }
    subtract(other) {
        return new Coordinate(this.x - other.x, this.y - other.y);
    }
    multiply(mult) {
        return new Coordinate(this.x * mult, this.y * mult);
    }
    dot(other) {
        return new Coordinate(this.x * other.x + this.y * other.y);
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    normalize() {
        let length = this.length();
        return new Coordinate(this.x / length, this.y / length);
    }
}
export default Coordinate;
